import template from './insuranceNotifications.html';
import controller from './insuranceNotificationsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    myParam: '<',
  },
};
